<div mat-dialog-title class="d-flex flex-column position-relative">
  <button
    mat-icon-button
    mat-dialog-close
    class="align-self-end"
    color="accent"
  >
    <mat-icon>close</mat-icon>
  </button>
  <div class="profile-title d-flex flex-column align-items-center">
    <img
      [src]="
        data['imageUrl'] !== null && data['imageUrl'] !== 'null'
          ? data['imageUrl']
          : './assets/images/user-avatar.svg'
      "
      class="img-fluid rounded-circle mx-auto mb-4"
    />
    <h2 class="mb-0">{{ data.name | titlecase }}</h2>
  </div>
</div>
<mat-dialog-content>
  <mat-list>
    <mat-list-item>
      <mat-icon mat-list-icon class="material-icons-outlined">place</mat-icon>
      <div mat-line>
        Address: <span>{{ data.state }}</span>
      </div>
    </mat-list-item>
    <mat-divider></mat-divider>
    <mat-list-item>
      <mat-icon mat-list-icon class="material-icons-outlined"
        >account_circle</mat-icon
      >
      <div mat-line>
        Gender: <span>{{ data.gender }}</span>
      </div>
    </mat-list-item>
    <mat-divider></mat-divider>
    <mat-list-item>
      <mat-icon mat-list-icon class="material-icons-outlined">event</mat-icon>
      <div mat-line>
        Date of birth: <span>{{ data.dateOfBirth | date }}</span>
      </div>
    </mat-list-item>
    <mat-divider></mat-divider>
    <mat-list-item>
      <mat-icon mat-list-icon class="material-icons-outlined">phone</mat-icon>
      <div mat-line>
        Phone number: <span>{{ data.phone }}</span>
      </div>
    </mat-list-item>
    <mat-divider></mat-divider>
    <mat-list-item>
      <mat-icon mat-list-icon class="material-icons-outlined"
        >admin_panel_settings</mat-icon
      >
      <div mat-line>
        User type: <span>{{ data.userType }}</span>
      </div>
    </mat-list-item>
  </mat-list>
</mat-dialog-content>
